exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-footer[data-v-43cb1f51]:empty{border:none;padding:0}.panel[data-v-43cb1f51]{margin-top:15px}.panel-heading[data-v-43cb1f51]{font-weight:700}.panel-body[data-v-43cb1f51]:empty{padding:0}.panel-body[data-v-43cb1f51]{word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43cb1f51","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/Panel.vue
// module id = 252
// module chunks = 0